import { Injectable } from '@angular/core';

// biome-ignore lint/complexity/noBannedTypes: Required for facebook pixel
declare let fbq: Function;

@Injectable({
    providedIn: 'root',
})
export class FacebookPixelEventTrackerService {
    public trackEvent(event: string) {
        if (typeof fbq === 'undefined') {
            return;
        }
        fbq('track', event);
    }
}
